import { RoleDto } from '../role/types';

// User action types
export const GET_USERS_REQUEST = 'USER_GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'USER_GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'USER_GET_USERS_FAILURE';

export const GET_USER_REQUEST = 'USER_GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'USER_GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'USER_GET_USER_FAILURE';

export const CREATE_USER_REQUEST = 'USER_CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'USER_CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'USER_CREATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'USER_UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'USER_UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'USER_UPDATE_USER_FAILURE';

export const UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'USER_UPDATE_PASSWORD_FAILURE';

export const CHANGE_USER_REQUEST = 'USER_DELETE_USER_REQUEST';
export const CHANGE_USER_SUCCESS = 'USER_DELETE_USER_SUCCESS';
export const CHANGE_USER_FAILURE = 'USER_DELETE_USER_FAILURE';

export const CLEAR_USER_STATE = 'USER_CLEAR_STATE';
export const SET_SELECTED_USER = 'USER_SET_SELECTED_USER';

export interface UserDto {
  _id?: string;
  name: string;
  email: string;
  surname?: string;
  // Multi-role support
  roleIds: string[];
  roles: RoleDto[];
  permissions: string[];
  createdAt?: string;
  updatedAt?: string;
  image?: string;
  enabled: boolean;
}

export interface UserState {
  users: UserDto[];
  selectedUser: UserDto | null;
  loading: boolean;
  error: string | null;
  success: boolean;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
  };
}
export interface GetUsersPayload {
  users: UserDto[];
  pagination: {
    current: number;
    pageSize: number;
    total: number;
  };
}

export interface CreateUserReq {
  name: string;
  email: string;
  // Multi-role support
  roleIds: string[];
  password?: string;
}

export interface UpdateUserReq {
  id: string;
  name: string;
  email: string;
  // Multi-role support
  roleIds: string[];
}

export interface UpdatePasswordReq {
  id: string;
  password: string;
}

export interface UpdateUserStatusReq {
  id: string;
  enabled: boolean;
}
